import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalDialogNotificationService, NotificationType } from '../../services/notification.service';
import { SeModalDialogComponent } from '../se-modaldialog/se-modaldialog.component';
import { ButtonClick, ModalWindowSize } from '../se-modalwindow/se-modalwindow.component';

@Component({
    selector: 'se-modaldialog-notifications',
    templateUrl: './se-modaldialog-notifications.component.html',
    styleUrls: ['./se-modaldialog-notifications.component.css'],
    standalone: false
})
export class SeModalDialogNotificationsComponent extends SeModalDialogComponent implements OnInit, OnDestroy {
    // data members

    private _notificationSubscriber: Subscription | null = null;

    messageListData?: string[];

    // constructor

    constructor(private notificationService: ModalDialogNotificationService) {
        super();
    }

    // public functions

    ngOnInit() {
        this.notificationService.register(this);

        this._notificationSubscriber = this.notificationService.notification.subscribe((notification) => {
            this.header = notification.title;
            this.description = notification.message;
            this.isError = notification.type == NotificationType.error;
            this.isWarning = notification.type == NotificationType.warning;

            this.buttonOk = notification.buttonOk;
            this.buttonCancel = notification.buttonCancel;
            this.buttonYes = notification.buttonYes;
            this.buttonNo = notification.buttonNo;

            this.messageListData = notification.messageListData;

            this.visible = true;
            this.windowSize = notification.windowSize ?? ModalWindowSize.seMessageBox;
        });
    }

    ngOnDestroy() {
        this.notificationService.unregister();
        this._notificationSubscriber?.unsubscribe();
    }

    onButtonClick(buttonClick: ButtonClick) {
        this.buttonClick.emit(buttonClick);
    }

    onVisibileChange(visible: boolean) {
        this.visible = visible;
    }
}
